import React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type ReadOnlyFieldProps = {
    label: string;
    value: string;
    slot: string;
};

/** A labeled, read-only value — used to show an existing variant's prefilled
 *  catalog fields (category, brand, unit, VAT, variation) that can't be edited. */
export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
    label,
    value,
    slot,
}) => (
    <div
        className="flex flex-col gap-1"
        {...getNodeTestIdProp(`manual-import-readonly-${slot}`)}
    >
        <span className="text-xs text-muted">{label}</span>
        <span
            className="truncate text-sm font-medium text-foreground"
            {...getNodeTestIdProp(`manual-import-readonly-value-${slot}`)}
        >
            {value || '—'}
        </span>
    </div>
);
